<template>
  <div class="agreement-order-tab tb">
    <custom-tab :list="tabData" v-model="tabIndex"></custom-tab>
    <manage v-if="tabIndex === 0"></manage>
    <device-list v-if="tabIndex === 1"></device-list>
  </div>
</template>

<script>
import manage from './children/manage.vue';
import deviceList from './children/deviceList.vue';

export default {
  name: 'agreementOrder',
  props: {},
  components: {
    deviceList,
    manage,
  },
  mixins: [],
  data() {
    return {
      tabIndex: 0,
    };
  },
  computed: {
    tabData() {
      const tabData = [];
      if (this.funcView.agreement_order_list) {
        tabData.push({
          name: this.$t('crm_agreementOrder.ding_dan'),
          value: 0,
        });
      }
      if (this.funcView.agreement_order_device_list) {
        tabData.push({
          name: this.$t('crm_agreementOrder.she_bei'),
          value: 1,
        });
      }
      return tabData;
    }
  },
  mounted() {
    this.getFuncView(null, () => {
      // 根据权限设置默认选中的tab
      if (this.tabData.length > 0) {
        // 如果订单权限不存在，则默认选中设备tab
        if (!this.funcView.agreement_order_list) {
          this.tabIndex = 1;
        } else {
          this.tabIndex = 0;
        }
      }
    });
  },
  methods: {},
};
</script>

<style lang="scss">
.agreement-order-tab {
  padding-left: 0 !important;
}
</style>
